export const TEST_ACCESS_TOKEN = '90f05a8ed9ef91c5bd5252ef27e82049d8160a28ba5dd4a65b8c3fe912b380fa'
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
export const HOSTNAME = process.env.REACT_APP_HOSTNAME || window.location.hostname
export type QrTagEventType = string
export type QrTagEventTypeEntry = {
  id: number
  name: string
  color: string | null
  position: number
}
